import ListProcesses from "@/views/service_provider/delivery/reporting/ListProcesses.vue";
import ShowProcess from "@/views/service_provider/delivery/reporting/ShowProcess.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "sp",
  role: "delivery",
  permission: "reporting",
});

export default [
  {
    path: "/sp/:service_provider_id/delivery/reporting/list_processes",
    name: routeName(""),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/sp/:service_provider_id/delivery/reporting/show_process/:delivery_process_id",
    name: routeName("show_process"),
    component: ShowProcess,
    props: true,
    meta: META,
  }
]
